import styled from 'styled-components';

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  & .buttonWrapper {
    display: flex;
    grid-gap: 10px;
    padding: 20px 0 10px;
  }

  & p {
    text-transform: capitalize;
  }

  .centerText {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .defaultMethod {
    background: var(--color-surface-disabled);
  }

  .topUpText {
    font-size: 12px;
    font-weight: 600;
    line-height: 18px;
    text-align: left;
    color: var(--color-text-muted);
  }

  .descriptionText {
    font-size: 12px;
    font-weight: 400;
    line-height: 15.6px;
    text-align: left;
    color: var(--color-text-muted);
  }

  .inputLabelText {
    font-size: 12px;
    font-weight: 500;
    line-height: 12px;
    text-align: left;
    color: var(--color-text-muted);
  }

  .note-text {
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 15.6px;
    color: var(--color-text-muted);
    margin-top: 15px;
    margin-bottom: 10px;
  }

  .error-text {
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 15.6px;
    margin-top: 15px;
    margin-bottom: 10px;
  }
`;
